import { Component, Input, OnInit, ViewEncapsulation, TemplateRef } from '@angular/core';
import * as moment from 'moment';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService, encryptStorage } from 'src/app/auth/auth.service';
import { AccountMasterService } from '../account-master.services';
import { NotificationSearch } from '../../../models/notification';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { emptyFields } from 'src/app/utilities/common-file';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class NotificationsComponent implements OnInit {
  notificationsModal: NzModalRef;
  @Input() newMessageCount: number;
  userId: number;
  userNotificationTime: any;
  loading=false;
  loadingForNotification = false;
  isVisible=false;
  loggedInUserAppcode:any;
  emptyField = emptyFields;
  loadingTextForNotification = 'Loading';
  btnLoading = false;
  newMesageList = [];
  private static AUTH_USER_APPCODE = 'AUTH_USER_APPCODE';
  public tableData: NzTableData<NotificationSearch, any> = new NzTableData<NotificationSearch, any>(new NotificationSearch(), 'fullName');
  constructor(private modal: NzModalService, private firestore: AngularFirestore, private authService: AuthService,private notificationService: AccountMasterService) {

  }
  ngOnInit() {
    this.userNotificationTime = moment().utc().format();
    this.updateNotificationTime();
    this.loggedInUserAppcode = encryptStorage.getItem(NotificationsComponent.AUTH_USER_APPCODE);
    this.getAllNotifications();
  }
  updateNotificationTime() {
    const currentTime = {
      notificationTime: this.userNotificationTime
    };
    this.firestore.collection('merchant_users').doc(this.authService.getUserId().toString()).set(currentTime, {
      merge: true
    }).then(res => {
      this.getMessages();
    }, err => {
      console.log("Update last message read time error");
      console.log(err)
    });
  }
  getMessages() {
    this.newMesageList = [];
    this.loadingForNotification = true;
    this.loadingTextForNotification = 'Loading';
    const mQuery = this.firestore.collection('merchant_users').doc(this.authService.getUserId().toString()).collection('notifications').ref;
    mQuery.orderBy('createdDate', 'desc').limit(5).get().then(snapshot => {
      if (snapshot.docs.length > 0) {
        snapshot.forEach(doc => {
          let messages = doc.data();
          this.newMesageList.push(messages);
        });
      } else {
        this.newMesageList = [];
        this.loadingForNotification = false;
        this.loadingTextForNotification = 'No Notifications Found';
      }
    }, err => {
      this.newMesageList = [];
      this.loadingForNotification = false;
      this.loadingTextForNotification = 'No Notifications Found';
    });
  }
  getLetterIcon(name: string) {
    if (name) {
      return name.charAt(0);
    } else {
      return '';
    }
  }
  getAllNotifications(startFromPageOne: boolean = true): void {
    this.btnLoading = true;
    this.loading= true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1; 
    }
    this.tableData.search.pageSize = 5;
    this.tableData.pageSize = 5;
    this.tableData.search.module = '';
    this.tableData.search.userId=this.authService.getUserId().toString();
    this.notificationService.getNotificationListWithLimit(this.tableData).subscribe((response: any) => {
      this.btnLoading = false;
      this.loading=false;
      this.isVisible=true;
      this.tableData.total = response.data.total;
      this.tableData.data = response.data.userNotifications;
    }, err => {
      this.btnLoading = false;
      this.loading=false;
    });
  }

  handleCancel(){
    this.isVisible=false;
  }
   onIndexChange(event) {
this.tableData.pageIndex = event;
this.getAllNotifications(false);
}

 // Modal Pop up to Chose Appcode
 createTplModal(
  notificationsTitle: TemplateRef<{}>,
  notificationsContent: TemplateRef<{}>,
  notificationsFooter: TemplateRef<{}>
) {
  this.notificationsModal = this.modal.create({
    nzTitle: notificationsTitle,
    nzContent: notificationsContent,
    nzFooter: notificationsFooter,
    nzMaskClosable: false,
    nzClosable: false,
    nzWidth: '75%',
    nzBodyStyle: {
      padding: '0'
    },
    nzOnOk: () => console.log('Click ok'),
  });
  this.getAllNotifications();
}

destroyModal() {
  this.notificationsModal.destroy();
}
}
